import RecoverStep from "./recover_step";

const TEMPLATE = 'conduct-d2c-bmr';

export default class ConductD2cBmr extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    postRender(data, el, fr) {
        $(el).find('#app_help a').on('click', function () {
            fr.callMethod("transitionContactSupport");
        });
    }

    transitionContactSupport(data, el, fr) {
        data.render = { assistance_needed: true };
        fr.goTo('notAvailable');
    }

}
